import { render, staticRenderFns } from "./ActivityParkCommentForm.vue?vue&type=template&id=60e85c1f&"
import script from "./ActivityParkCommentForm.vue?vue&type=script&lang=js&"
export * from "./ActivityParkCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports